export default __webpack_public_path__ + "static/media/rupee-icon.646f858b.svg";